import React from "react";
import { withStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import { useStyles } from "./indexStyles";

function FieldLabel({
  classes: { label: labelText },
  label = null,
  variant = "caption",
  color = "black",
  fontWeight = 450,
  mb = 1,
}) {
  return (
    <Typography
      variant={variant}
      className={labelText}
      mb={mb}
      fontWeight={fontWeight}
      color={color}
    >
      {label}
    </Typography>
  );
}

export default withStyles(useStyles, { withTheme: true })(FieldLabel);
